export const FEATURE_FLAGS = {
  jobs: true,
  analytics: true,
  financials: true,
  notifications: true,
  payroll: true,
}
